import { render } from "./SongPage.vue?vue&type=template&id=344b74e2&scoped=true"
import script from "./SongPage.vue?vue&type=script&lang=js"
export * from "./SongPage.vue?vue&type=script&lang=js"

import "./SongPage.vue?vue&type=style&index=0&id=344b74e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344b74e2"]])

export default __exports__